module.exports = __webpack_public_path__ + "header-logo-58e91c96223b3a27e316c0ad7f08c8dd.png";